import { useStoreActions, useStoreState } from 'easy-peasy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PageContainer } from '@ge/components/containers';
import { Select } from '@ge/components/select';

const StyledSelect = styled(Select)`
  width: 120px;
  height: 40px;
  .select__control {
    min-height: 40px;
  }
`;

const StyledLabel = styled.label`
  margin-bottom: 4px;
  display: block;
`;

const ProfilePage = styled.div`
  padding: 20px;
`;

export const Profile = () => {
  const { t } = useTranslation();
  const { setLanguage } = useStoreActions((actions) => actions.prefs);
  const { language } = useStoreState((state) => state.prefs);

  const handleLanguageChange = (selectedOption) => {
    setLanguage(selectedOption.value);
  };

  const languageOptions = [
    { value: 'en', label: t('english', 'English') },
    { value: 'de', label: t('german', 'German') },
    { value: 'pt-BR', label: t('portuguese', 'Portuguese-BR') },
  ];

  return (
    <PageContainer>
      <h1 className="pageTitle">{t('profile', 'Profile')}</h1>
      <ProfilePage>
        <StyledLabel className="body-1" htmlFor="lang">
          {t('language', 'Language')}:
        </StyledLabel>
        <StyledSelect
          id="lang"
          value={languageOptions.find((option) => option.value === language)}
          options={languageOptions}
          onChange={handleLanguageChange}
        />
      </ProfilePage>
    </PageContainer>
  );
};
